import { FC } from '../../Services'
import { prepareDefaultPreset, prepareSelectedFilters, prepareServicePriority } from './Functions'

export const savePreset = async ({ groups } = {}, method, params) => {
  const {
    setIsSaving,
    selectedTrainFilters,
    inputTrainValues,
    flagAbilitazione,
    inputRimborsoTrain,
    inputNoRimborsoTrain,
    selectedPlaneFilters,
    inputPlaneValues,
    selectedHotelFilters,
    inputHotelValues,
    selectedCarFilters,
    inputCarValues,
    servicePriority,
    trainFarePriority,
    selectedClient,
    ragioneSociale,
    defaultPreset,
    codiceGruppo,
    initialDefaultPreset,
    setInitialDefaultPreset,
    presetId,
    navigate,
    user,
    requestData
  } = params

  setIsSaving(true)
  try {
    const [group] = groups || []
    const selectedTrainFiltersPrepared = prepareSelectedFilters(
      selectedTrainFilters,
      inputTrainValues,
      flagAbilitazione,
      inputRimborsoTrain,
      inputNoRimborsoTrain
    )
    const selectedPlaneFiltersPrepared = prepareSelectedFilters(
      selectedPlaneFilters,
      inputPlaneValues
    )
    const selectedHotelFiltersPrepared = prepareSelectedFilters(
      selectedHotelFilters,
      inputHotelValues
    )
    const selectedCarFiltersPrepared = prepareSelectedFilters(selectedCarFilters, inputCarValues)
    const servicePriorityPrepared = await prepareServicePriority(servicePriority)
    const requestDataFinal = {
      ...requestData,
      selectedPlaneFilters: selectedPlaneFiltersPrepared,
      selectedTrainFilters: selectedTrainFiltersPrepared,
      selectedHotelFilters: selectedHotelFiltersPrepared,
      selectedCarFilters: selectedCarFiltersPrepared,
      servicePriority: servicePriorityPrepared,
      trainFarePriority
    }

    requestDataFinal.codiceCliente = selectedClient ? selectedClient.codCliente12 : null
    requestDataFinal.ragioneSociale = selectedClient ? ragioneSociale : null

    if (defaultPreset) {
      requestDataFinal.codiceGruppo = ''
      requestDataFinal.descrizione = ''
    } else {
      requestDataFinal.codiceGruppo = !selectedClient ? codiceGruppo : null
      requestDataFinal.descrizione = !selectedClient ? group?.descrizione : null
    }

    await prepareDefaultPreset(
      defaultPreset,
      initialDefaultPreset,
      setInitialDefaultPreset,
      user.user.environmentId
    ) // tolgo il defaultPreset dalla community dello stesso environment (società) dell'utente di appartenenza

    const res = await FC.service('communityPreset')[method](
      ...[method === 'patch' ? presetId : undefined, requestDataFinal].filter(Boolean)
    )

    res?.id && navigate('/community/panel/modify/' + res?.id?.toString())
    return res
  } finally {
    setIsSaving(false)
  }
}
